import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async create(data) {
    return await axiosIns.post(obtenerUrlAPIPagos('modulos-programas-universidades'), data);
  },
  async findAll(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('modulos-programas-universidades'), { params: opciones.params });
  },
  async findOne(id) {
    return await axiosIns.get(obtenerUrlAPIPagos(`modulos-programas-universidades/${id}`));
  },
  async update(id, data) {
    return await axiosIns.patch(obtenerUrlAPIPagos(`modulos-programas-universidades/${id}`), data);
  },
  async remove(id) {
    return await axiosIns.delete(obtenerUrlAPIPagos(`modulos-programas-universidades/${id}`));
  },
};
